import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Diagram, {
    Nodes,
    AutoLayout,
    Edges,
    Toolbox,
    Group,
} from 'devextreme-react/diagram';

import config from 'devextreme/core/config';

const OBDiagram = (props) => {
    const [componentKey, setComponentKey] = useState(0);

    const {
        id,
        orgItemsDataSource,
        orgLinksDataSource,
        title,
        setProps,
        imageUrlExpr,
        orientation,
        autolayoutType,
        readOnly,
        simpleView,
        // fullScreen,
        showGrid,
        toolboxVisibility,
        style,
        lng,
        licenseKey,
        ...DiagramProps
    } = props;

    config({ licenseKey });

    return (
        <Diagram
            id={id}
            {...DiagramProps}
            key={componentKey}
            style={style}
            readOnly={readOnly}
            simpleView={simpleView ? simpleView : DiagramProps.simpleView}
            // fullScreen={fullScreen ? fullScreen : DiagramProps.fullScreen}
            showGrid={showGrid ? showGrid : DiagramProps.showGrid}
        >
            <Nodes
                dataSource={orgItemsDataSource}
                imageUrlExpr={imageUrlExpr}
            >
                <AutoLayout
                    orientation={orientation}
                    type={autolayoutType}
                />
            </Nodes>
            <Edges dataSource={orgLinksDataSource} />
            <Toolbox 
                visibility={toolboxVisibility}
            />
        </Diagram>
    );
};

OBDiagram.propTypes = {
    id: PropTypes.string,
    orgItemsDataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    orgLinksDataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    title: PropTypes.string,
    imageUrlExpr: PropTypes.string,
    orientation: PropTypes.string,
    lng: PropTypes.string,
    autolayoutType: PropTypes.string,
    readOnly: PropTypes.bool,
    simpleView: PropTypes.bool,
    // fullScreen: PropTypes.bool,
    showGrid: PropTypes.bool,
    toolboxVisibility: PropTypes.bool,
    style: PropTypes.object,
    setProps: PropTypes.func,
    licenseKey: PropTypes.string,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
};

OBDiagram.defaultProps = {
    lng: 'en',
    orientation: 'horizontal',
    imageUrlExpr: 'picture'
};

export default OBDiagram;
